var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateCampaignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.36 20.36H25.27C24.37 20.36 23.63 19.63 23.63 18.72V1.64C23.63 0.74 22.9 0 21.99 0C21.09 0 20.35 0.73 20.35 1.64V18.73C20.35 19.63 19.62 20.37 18.71 20.37H1.64C0.74 20.37 0 21.1 0 22.01C0 22.91 0.73 23.65 1.64 23.65H18.73C19.63 23.65 20.37 24.38 20.37 25.29V42.38C20.37 43.28 21.1 44.02 22.01 44.02C22.91 44.02 23.65 43.29 23.65 42.38V25.29C23.65 24.39 24.38 23.65 25.29 23.65H42.38C43.28 23.65 44.02 22.92 44.02 22.01C44.02 21.11 43.29 20.37 42.38 20.37L42.36 20.36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCampaignIcon);
export default __webpack_public_path__ + "static/media/createCampaignIcon.5cac4de9af005816538dc6c752541974.svg";
export { ForwardRef as ReactComponent };